import images1 from '../../assets/images/1.jpg'
import images2 from '../../assets/images/2.jpg'
import images3 from '../../assets/images/3.jpg'
import images4 from '../../assets/images/4.jpg'
import images5 from '../../assets/images/5.jpg'
import images6 from '../../assets/images/6.jpg'
import images7 from '../../assets/images/7.jpg'
import images8 from '../../assets/images/8.jpg'
import images9 from '../../assets/images/9.jpg'

const ProjectsData = [
    {
        id: 1,
        title: 'Job Title',
        description: 'It is a long established fact that a reader will be distracted by the readable.',
        category: 'design',
        image: images1,
    },
    {
        id: 2,
        title: 'Job Title',
        description: 'It is a long established fact that a reader will be distracted by the readable.',
        category: 'graphics',
        image: images2,
    },
    {
        id: 3,
        title: 'Job Title',
        description: 'It is a long established fact that a reader will be distracted by the readable.',
        category: 'design',
        image: images3,
    },
    {
        id: 4,
        title: 'Job Title',
        description: 'It is a long established fact that a reader will be distracted by the readable.',
        category: 'video',
        image: images4,
    },
    {
        id:5,
        title: 'Job Title',
        description: 'It is a long established fact that a reader will be distracted by the readable.',
        category: 'graphics',
        image: images5,
    },
    {
        id:6,
        title: 'Job Title',
        description: 'It is a long established fact that a reader will be distracted by the readable.',
        category: 'video',
        image: images6,
    },
    {
        id:7,
        title: 'Job Title',
        description: 'It is a long established fact that a reader will be distracted by the readable.',
        category: 'design',
        image: images7,
    },
    {
        id:8,
        title: 'Job Title',
        description: 'It is a long established fact that a reader will be distracted by the readable.',
        category: 'video',
        image: images8,
    },
    {
        id:9,
        title: 'Job Title',
        description: 'It is a long established fact that a reader will be distracted by the readable.',
        category: 'graphics',
        image: images9,
    }
]

export default ProjectsData